import { Storage } from '@ionic/storage';
import { UserState } from '../../../../hooks/authUtils';
import { EquipmentGenericItemType } from '../../../../graphql/EquipmentGenericItemType';
import useBaseCacheAndList from '../../../../hooks/baseCacheAndList';
import GET_EQUIPMENT_BRANCHES_LIST from '../graphql/GetEquipmentBranches';
import equipmentKeys from './equipmentKeys';
import { DomainParams } from '../../../../hooks/graphQLClientUtil';

const useEquipmentBranches = (region: number, userState: UserState, storage: Storage) => {
  const equipmentBranches: EquipmentGenericItemType[] = useBaseCacheAndList(
    region,
    userState,
    storage,
    GET_EQUIPMENT_BRANCHES_LIST,
    equipmentKeys.equipmentBranches(),
    'branches',
    DomainParams.Equipments);
  return equipmentBranches;
};

export default useEquipmentBranches;